.me-page {
  max-width: 760px;
  margin: 0 auto;
  padding: 1.5rem 1rem 2rem;
}

.page-title {
  justify-content: center;
}

.panel {
  margin-bottom: 1.5rem;
  overflow: hidden;
  background-color: var(--umati-card-bg, #fff);
  border: 1px solid var(--umati-border, #e5e7eb);
  border-radius: var(--umati-radius-lg, 12px);
  box-shadow: var(--umati-shadow, none);
}

.panel-header {
  margin: 0;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  background-color: #fafbfc;
  border-bottom: 1px solid var(--umati-border, #e5e7eb);
}

.panel-body {
  padding: 1.25rem 1.5rem;
}

.details {
  margin: 0;
}

.details-row {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f2f5;
}

.details-row:first-child {
  padding-top: 0;
}

.details-row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.details dt {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--umati-muted);
}

.details dd {
  margin: 0;
  font-size: 0.95rem;
  overflow-wrap: anywhere;
}

@media (max-width: 480px) {
  .details-row {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.company-tag {
  display: inline-block;
  padding: 0.15rem 0.6rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--umati-blue);
  background-color: var(--umati-blue-soft, #e6f6fd);
  border: 1px solid rgb(1 167 231 / 30%);
  border-radius: 999px;
}

.password-form {
  max-width: 380px;
}
